module.exports = __webpack_public_path__ + "img/doc_3.26deea2c.png";